<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" foot-clone>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(materialName)="data">
          <div @click="showDetail(data.item.materialName)">{{ data.item.materialName }}</div>
        </template>
        <template v-slot:cell(materialModel)="data">
          {{ data.item.materialModel }}
        </template>
        <template v-slot:cell(materialUnit)="data">
          {{ data.item.materialUnit }}
        </template>
        <template v-slot:cell(purchaseQuantity)="data">
          {{ Number(data.item.purchaseQuantity).toFixed(2) }}
        </template>
        <template v-slot:cell(unitPrice)="data">
          {{ Number(data.item.unitPrice).toFixed(2) }}
        </template>
        <template v-slot:cell(amountMoney)="data">
          {{ Number(data.item.amountMoney).toFixed(2) }}
        </template>
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.width }"
          >
        </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
      </template>
      <template v-slot:foot(index)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
      </template>
      <template v-slot:foot(purchaseQuantity)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum2(items,'purchaseQuantity')}}</div>
      </template>
      <template v-slot:foot(amountMoney)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'amountMoney')}}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";

export default {
  name: "lxcgDetail",
  data(){
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'materialName', label: '材料名称', width: '170px'},
        {key: 'materialModel', label: '规格', width: '160px'},
        {key: 'materialUnit', label: '计量单位', width: '160px'},
        {key: 'purchaseQuantity', label: '采购数量', width: '120px'},
        {key: 'unitPrice', label: '含税单价', width: '100px'},
        {key: 'amountMoney', label: '含税金额', width: '120px'}
      ],
      items: []
    }
  },
  created(){
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init(){

    },
    goBack(){
      this.$router.back()
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass(){
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum2(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(4, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>